module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.5ecbc99d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Thin.ttf
// module id = 710
// module chunks = 4